import React from 'react'
import cx from 'classnames'
import { SectionItem } from '../Section'

import style from './style'

const PageTitle = ({ title, description, className }) => (
  <SectionItem
    title={title}
    description={description}
    className={cx(style.SettingsPageTitle, className)}
  />
)

export default PageTitle



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/PageTitle/index.js